export class TituloLogoPjus {
  titulo: string;
  urlImagem: string;
  urlImagemMobile: string;
  opcaoVoltar: boolean = false;
  utilizarMargin: boolean = true;
  routerLink: string;
  exibirLabelVoltar: boolean = true;

  constructor(other?: any) {
    this.titulo = other.titulo;
    this.urlImagem = other.urlImagem;
    this.urlImagemMobile = other.urlImagemMobile;
    this.opcaoVoltar = other.opcaoVoltar;
    this.utilizarMargin = other.utilizarMargin;
    this.routerLink = other.routerLink;
    this.exibirLabelVoltar = other.exibirLabelVoltar;
  }
}
